import { useNavigate } from "react-router-dom";
import { MTButton } from "../../../components/button/MTButton";
import { HeaderTitle } from "../../../components/header/Header";
import Container from "../../../components/layout/Container";
import { STYLE_REPORT_CONTAIN } from "../../../utils/useStyle";
import { CardReportAverage } from "../components/cardMenu";
import { HeaderReport } from "../components/header.main";
import {
  HeaderTableReport,
  HeaderTitleTableReport,
  TableReport,
} from "../components/table.main";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useEffect, useMemo } from "react";
import { first_reload } from "../../tax_plan/functions/firstLoad";
import { DonutChartMain } from "../../../components/chart/DonutChartMain";
import numeral from "numeral";
import { cn } from "../../../utils/useFunctions";
import { calculateExpenseSummary } from "../../../functions/Balance/expense-summary";

// แสดงกราฟและสัดส่วนรายจ่ายจากผลสรุปชุดเดียวกัน เพื่อให้ยอดกลางกราฟตรงกับตัวหารของทุกหมวด
const ChartSection = ({ expenseSummary, items }) => {
  return (
    <div className=" flex flex-col items-center">
      <DonutChartMain
        className=" -mt-20"
        classNameText={
          " text-sm  absolute top-[59%] left-1/2 -translate-x-1/2 -translate-y-1/4 text-black font-IBMPlexSansThai text-center"
        }
        classNameValue={" text-base"}
        classNameDonut=" w-[250px] pb-3"
        classNameGray="bg-white h-[66px]"
        text={`ค่าใช้จ่าย`}
        value={numeral(expenseSummary.expenseIncludingAllocation).format(
          "0,0"
        )}
        data1={expenseSummary.fixedExpense}
        data2={expenseSummary.variableExpense}
        data3={expenseSummary.savingAndInvestmentExpense}
      />

      <div className=" flex flex-col justify-center ">
        {items?.map((item, index) => {
          return (
            <div key={index} className=" flex items-center gap-2.5 font-medium">
              <div className={` ${item?.color} h-2 w-5`}></div>
              <div className="flex items-center text-xs gap-1">
                <div>
                  {item?.title}{" "}
                  <span className=" font-bold">
                    {numeral(item?.sum_per_year)?.format("0,0")}
                  </span>{" "}
                  บาท คิดเป็น{" "}
                  <div className={` ${item?.textcolor} font-bold text-sm `}>
                    {item?.sum_percent?.toFixed(2)} %
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const TableExpense = ({ items }) => {
  return (
    <div className="bg-gray50 rounded-[20px] w-full h-ful p-3">
      <HeaderTableReport
        title="แหล่งที่มาของรายจ่าย"
        textjusify="text-center"
      />
      {items?.map((item, index) => {
        return (
          <div key={index} className={cn("  items-center")}>
            <div className=" col-span-full">
              <HeaderTitleTableReport
                img={`/images/${item?.icon}`}
                title={item?.title}
              />
            </div>

            <div
              className={`bg-[#F9F9F9] py-1 rounded-[10px] grid grid-cols-8 px-2 items-center font-semibold text-mainblue text-sm`}
            >
              <div className=" col-span-3 ">
                {/* <HeaderTitleTableReport
              img={`/images/${item?.icon}`}
              title={item?.title}
            /> */}
              </div>
              <div className=" col-span-2 text-right">
                {numeral(item.sum_per_month).format("0,0.00")}
              </div>
              <div className="col-span-3 text-right ">
                {numeral(item.sum_per_year).format("0,0")} บาท
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

// อธิบายเฉพาะเงินสดสุทธิที่เป็นบวกซึ่งระบบนำมาจัดประเภทเป็นรายจ่ายเพื่อออมและลงทุน
const ExplanSection = ({ positiveResidualAllocation }) => {
  if (positiveResidualAllocation <= 0) return null;

  return (
    <div className="text-center text-gray90 text-xs">
      จากกระแสเงินสดสุทธิ {numeral(positiveResidualAllocation).format("0,0")}{" "}
      บาท ให้สมมติฐานว่านำมาบันทึกเป็นค่าใช้จ่ายเพื่อออมและลงทุน
    </div>
  );
};

// สร้างรายงานสัดส่วนรายจ่ายจาก owner กลางทั้งยอดรวม รายการรายเดือน/รายปี และเปอร์เซ็นต์ของแต่ละหมวด
const ReportExpensePage = () => {
  const navigate = useNavigate();
  const balanceData = useBalanceStore((state) => state.balanceData);
  const expenseSummary = useMemo(
    () => calculateExpenseSummary(balanceData),
    [balanceData]
  );

  const createSumObject = (sum_per_month, sum_per_year, sum_percent) => ({
    sum_per_month: sum_per_month || 0,
    sum_per_year: sum_per_year || 0,
    sum_percent: sum_percent || 0,
  });

  const sumFixed = useMemo(() => {
    return createSumObject(
      expenseSummary.fixedExpense / 12,
      expenseSummary.fixedExpense,
      expenseSummary.expensePercentages.fixed
    );
  }, [expenseSummary]);

  const sumVariable = useMemo(() => {
    return createSumObject(
      expenseSummary.variableExpense / 12,
      expenseSummary.variableExpense,
      expenseSummary.expensePercentages.variable
    );
  }, [expenseSummary]);

  const sumExpensesInvestSaving = useMemo(() => {
    return createSumObject(
      expenseSummary.savingAndInvestmentExpense / 12,
      expenseSummary.savingAndInvestmentExpense,
      expenseSummary.expensePercentages.savingAndInvestment
    );
  }, [expenseSummary]);

  const items = useMemo(() => {
    return [
      {
        title: "ค่าใช้จ่ายคงที่",
        icon: "accounting.svg",
        ...sumFixed,
        color: "bg-yellow400",
        textcolor: "text-yellow400",
      },
      {
        title: "ค่าใช้จ่ายแปรผัน",
        icon: "cost (1).svg",
        ...sumVariable,
        color: "bg-red500",
        textcolor: "text-red-500",
      },
      {
        title: "ค่าใช้จ่ายเพื่อการออม/ลงทุน",
        icon: "bank.svg",
        classNameIcon: "w-[24px]",
        ...sumExpensesInvestSaving,
        color: "bg-maingreen",
        textcolor: "text-maingreen",
      },
    ];
  }, [sumFixed, sumVariable, sumExpensesInvestSaving]);


  useEffect(() => {
    let ignore = false;
    first_reload(ignore);
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <Container>
      <div id="first_reload" className="pt-[14px]">
        <HeaderTitle
          title="รายงาน"
          isGoback
          onClickGoBack={() => {
            navigate("/report");
          }}
        />

        <div className={`${STYLE_REPORT_CONTAIN} flex flex-col gap-5`}>
          <HeaderReport
            icon={"/images/expense-report.png"}
            title={"สัดส่วนรายจ่ายของคุณ"}
            className={" z-20"}
          />
          <ChartSection expenseSummary={expenseSummary} items={items} />
          <CardReportAverage
            value={numeral(
              expenseSummary.expenseIncludingAllocation / 12
            ).format("0,0.00")}
          />
          <TableExpense items={items} />
          <ExplanSection
            positiveResidualAllocation={
              expenseSummary.positiveResidualAllocation
            }
          />

          <div className=" flex justify-center ">
            <MTButton
              onClick={() => {
                navigate("/report");
              }}
              text="ย้อนกลับ"
              color="bg-white"
              border="border border-maincyan"
              colortext="text-maincyan group-hover:text-white"
              hovercolor="hover:bg-maincyan group "
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ReportExpensePage;
